export const selectNoteTypeFiltersState = (state) => state.noteTypeFilters || {};

export const selectNoteTypeFilters = (state) => selectNoteTypeFiltersState(state).filters;
